import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'
import { AutoApprovalRouter } from './automation/_router'
import { CreditCardStatementRouter } from './credit-card-statement/_router'
import { EurocontrolRouter } from './eurocontrol/_router'
import { ExpectedInvoiceRouter } from './expected-invoices/_router'
import { ExpenseRouter } from './expense/_router'
import { InboundDocumentInboxRouter } from './inbox/_router'
import { IntermediaryAgencyPaymentCollectionRouter } from './intermediary-agency-payment-collection/_router'
import { PeppolInboxRouter } from './peppol-inbox/_router'
import { PersonalExpenseAccountMouvementDocumentRouter } from './personal-expense-account-mouvement-document/_router'
import { SupplierValidationRouter } from './supplier-validation/_router'

const Index = lazy(() => import('./Index'))

export const PurchaseRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--purchase']}>
    <Route index element={<Index />} />
    <Route path='expense/*' element={<ExpenseRouter />} />
    <Route path='belgian-departing-flight-taxes-expense/*' element={<ExpenseRouter />} />
    <Route path='italian-flight-taxes-expense/*' element={<ExpenseRouter />} />
    <Route
      path='intermediary-agency-payment-collection/*'
      element={<IntermediaryAgencyPaymentCollectionRouter />}
    />
    <Route
      path='personal-expense-account-mouvement-document/*'
      element={<PersonalExpenseAccountMouvementDocumentRouter />}
    />
    <Route path='peppol-inbox/*' element={<PeppolInboxRouter />} />
    <Route path='inbox/*' element={<InboundDocumentInboxRouter />} />
    <Route path='supplier-validation/*' element={<SupplierValidationRouter />} />
    <Route path='automation/*' element={<AutoApprovalRouter />} />
    <Route path='credit-card-statement/*' element={<CreditCardStatementRouter />} />
    <Route path='eurocontrol/*' element={<EurocontrolRouter />} />
    <Route path='expected-invoices/*' element={<ExpectedInvoiceRouter />} />
  </SubRouter>
))
